import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { subscribeAppUpdate } from "@/lib/appUpdate";

export default function UpdateAvailableToast() {
  const [needsRefresh, setNeedsRefresh] = useState(false);

  useEffect(() => subscribeAppUpdate(setNeedsRefresh) as unknown as () => void, []);

  if (!needsRefresh) return null;

  return (
    <div className="fixed bottom-4 inset-x-4 z-40 mx-auto max-w-sm animate-in slide-in-from-bottom duration-300">
      <div className="flex items-center gap-3 rounded-xl border border-border bg-card p-3 shadow-lg">
        <RefreshCw className="h-4 w-4 text-primary shrink-0" />
        <p className="text-sm text-foreground flex-1">A new version is ready</p>
        <Button size="sm" variant="default" onClick={() => window.location.reload()}>
          Refresh
        </Button>
      </div>
    </div>
  );
}
